import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Payment, Transaction } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOC_TYPES } from '../../core/constants/FormLists';
import { PseTransaction } from 'src/app/models/pse-transaction';
import { AlertService } from 'src/app/services/alert.service';
import { PayService } from 'src/app/services/pay.service';
import { isString } from 'lodash';
import { BUYER_INFORMATION_VALIDATIONS } from 'src/app/core/constants/Errors';
import { LEGAL_FILES } from '../../core/constants/URLs';
import { ALERT_ERRORS, PSE_VALIDATION } from '../../core/constants/Errors';
import { PseService } from '../../services/pse.service';
import { EmailValidator } from '../../tools/email-validator';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { AUTOCOMPLETE_METHOD_PAY_TYPES, BANCOLOMBIA_PSE_BANK_NAME, COMMERCIAL_NETWORKS_CODES, FLAGS_NAME, GENERAL_CONSTANTS, TYPE_CLIENTS } from 'src/app/core/constants/General-constants';
import { createMerchantReturnUrl } from 'src/app/shared/helps/helps';
import { PatchValAdditionalInfoService } from 'src/app/services/patch-val-additional-info.service';
import { PATTERN } from 'src/app/constants/pattern';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';

@Component({
    selector: 'app-pse-wallet',
    templateUrl: './pse-wallet.component.html',
    styleUrls: ['./pse-wallet.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PseWalletComponent implements OnInit {
    @Input() info: Payment;
    @Output() PSE = new EventEmitter();

    loading: boolean;
    transaction: Transaction;
    template: string;
    by_pseavanza: boolean;
    orderID: string;
    form: FormGroup;
    listOfDocuments = [];
    urlReturnMerchant: string;
    pseTransaction: PseTransaction;
    validate_document: boolean = false;
    personalDataURL = LEGAL_FILES.PERSONAL_DATA;
    errorsMessages = BUYER_INFORMATION_VALIDATIONS;
    errorsMessagesPSE = PSE_VALIDATION;
    bankTopay: string = '';
    token: string;
    formPrivacyValid: boolean = false;
    typeClients = TYPE_CLIENTS;
    isEditableInfo: boolean = false;
    walletsAutoCompleteFF: boolean = false;
    bankListBancolombiaName = BANCOLOMBIA_PSE_BANK_NAME;
    objectControlData = [
        {
            formControl: 'typeDI',
            readOnly: false,
        },
        {
            formControl: 'di',
            readOnly: false,
        },
        {
            formControl: 'cellPhone',
            readOnly: false,
        },
        {
            formControl: 'email',
            readOnly: false,
        },
        {
            formControl: 'address',
            readOnly: false,
        },
        {
            formControl: 'name',
            readOnly: false,
        },
        {
            formControl: 'personType',
            readOnly: false,
        },
    ];

    constructor(
        private readonly authService: AuthService,
        private readonly pseservice: PseService,
        private readonly formBuilder: FormBuilder,
        private readonly tokenServiceService: TokenServiceService,
        private readonly alertService: AlertService,
        private readonly payservice: PayService,
        private readonly patchValAdditionalInfoService: PatchValAdditionalInfoService,
        private readonly featureFlagService: PayvalidaFeatureFlagService
    ) {
        this.form = this.formBuilder.group({
            typeDI: ['', Validators.required],
            di: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(20),
                    Validators.minLength(6),
                    //TODO CREATE FILE FOR REGULAR EXPRESSIONS IN CONSTANTS
                    Validators.pattern('^[0-9-]*$'),
                ]),
            ],
            cellPhone: [''],
            email: [''],
            address: [''],
            //TODO CREATE FILE FOR REGULAR EXPRESSIONS IN CONSTANTS
            name: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[A-Za-zñÑáéíóúÁÉÍÓÚ. ]*$')])],
            personType: ['', Validators.required],
            token: ['', Validators.required],
        });
        const docTypesObjectKeys = Object.keys(DOC_TYPES);
        for (let prop of docTypesObjectKeys) {
            this.listOfDocuments.push(DOC_TYPES[prop]);
        }
    }
    /**
     * @description Function that initializes the component
     */
    ngOnInit(): void {
        this.onActivate();

        this.template = this.info.template;
        this.loading = true;
        this.by_pseavanza = false;
        this.orderID = this.authService.getOrderID();
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        this.urlReturnMerchant = createMerchantReturnUrl(this.orderID, this.transaction.MERCHANT_URL_RETURN);
        this.pseTransaction = new PseTransaction();
        this.pseTransaction.name = this.transaction.USER_NAME;
        this.pseTransaction.di = this.transaction.USER_DI;
        this.pseTransaction.typeDI = this.transaction.USER_TYPE_DI;
        const parameters = {
            token: this.tokenServiceService.getToken(),
        };

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF, FLAGS_NAME.WALLETS_AUTOCOMPLETE_FF).subscribe((response: boolean) => {
            this.walletsAutoCompleteFF = response;
        });

        this.pseservice.getListBancPost(parameters).subscribe((data: any) => {
            this.loading = false;
            this.pseTransaction.token = parameters.token;

            this.form.patchValue(this.pseTransaction);

            if (data.statusCode === 201) {
                this.by_pseavanza = data.nf;

                let bankCode = data.body.find((b) => {
                    if(this.isBancolombiaButton()) return b.BANK_NAME === this.bankListBancolombiaName;

                    return b.BANK_NAME === this.info.name;
                });

                if (bankCode) {
                    this.bankTopay = bankCode.BANK_CODE;
                }

                if (this.by_pseavanza) {
                    this.form.controls['address'].setValidators([
                        Validators.required,
                        Validators.minLength(5),
                        Validators.maxLength(50),
                    ]);

                    this.form.controls['email'].setValidators([Validators.required, EmailValidator.isValid, Validators.maxLength(150)]);
                    this.form.controls['cellPhone'].setValidators([
                        Validators.required,
                        Validators.maxLength(10),
                        Validators.minLength(10),
                        Validators.pattern(PATTERN.NUMBERS),
                    ]);

                    const additionalInfo = this.tokenServiceService.exitsAdditionalInformation(this.transaction);

                    if (additionalInfo && this.walletsAutoCompleteFF) return this.disabledItems(additionalInfo);
                }
            } else {
                this.loading = false;

                this.alertService.showAlert(ALERT_ERRORS.TRANSACTION_ERROR, 'warning');

                this.changeMethod();
            }
        });
    }

    /**
     *
     * @description {isControlReadOnly} function to check if form fields are read-only
     * @param controlName
     * @returns
     */
    isControlReadOnly(controlName: string): boolean {
        const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);

        return readOnlyControl ? readOnlyControl.readOnly : false;
    }

    /**
    *
    * @description {disabledItems} Function to disabled items to checkout form
    */
    disabledItems(additionalInfo) {
        try {
            this.isEditableInfo = this.tokenServiceService.isEditableInfo(additionalInfo);

            return this.patchValAdditionalInfoService.patchValAdditionalInfo(
                this.isEditableInfo,
                additionalInfo,
                this.form,
                AUTOCOMPLETE_METHOD_PAY_TYPES.PSE_WALLETS,
                this.objectControlData,
            );
        } catch (_) {
            this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
        }
    }

    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate = (valid: boolean) => {
        this.formPrivacyValid = valid;
    };
    /**
     *
     * @description {completedForms} Function to validate the validations of the parent component and child component
     * @returns
     */
    completedForms = (): boolean => {
        return this.form.valid && this.formPrivacyValid;
    };

    /**
     * @description Function that validates the payment form
     */
    async validData() {
        this.loading = true;
        this.pseTransaction = this.form.value;
        this.pseTransaction.di = this.pseTransaction.di.toString();
        if (this.completedForms()) {
            await this.processPayment();
        } else {
            this.loading = false;
            this.alertService.showAlert(ALERT_ERRORS.DATA_IMCOMPLETED, 'warning');
        }
    }

    /**
     * @description Function that processes the payment transaction
     */
    async processPayment() {
        try {
            this.pseTransaction.bank = this.bankTopay;
            const pseResponse: any = await this.payservice.pseTransaction(this.pseTransaction);
            this.loading = false;
            if (pseResponse.statusCode === 201) {
                window.location.href = pseResponse.body.URL_BANK;
            } else {
                this.loading = false;
                if (pseResponse.message != null && isString(pseResponse.message)) {
                    this.alertService.showAlert(pseResponse.message, 'error');
                } else {
                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'error');
                }
            }
        } catch (e) {
            this.loading = false;
            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'error');
        }
    }

    /**
     * @description Function that returns to payment methods
     */
    changeMethod() {
        this.PSE.emit();
    }

    /**
     * @description onActivate
     */
    onActivate() {
        window.scroll(0, 0);
    }

    /**
     * @description Function that validates the entered document
     */
    validDI() {
        if (this.form.value.di.includes('-')) {
            //TODO CREATE FILE FOR REGULAR EXPRESSIONS IN CONSTANTS
            const expresion = /^([0-9]+-{1}[0-9]{1})$/i;
            if (!expresion.test(this.form.value.di)) {
                this.validate_document = true;
            } else {
                this.validate_document = false;
            }
        }
    }

    /**
     * @description Function to validate that the payment method is the Bancolombia PSE button
    */
    isBancolombiaButton = () => this.info.code === COMMERCIAL_NETWORKS_CODES.BANCOLOMBIA_PSE_BTN && this.info.template === GENERAL_CONSTANTS.TEMPLATES.WALLET_PSE;
}
